import React from "react";
import AccountBalanceOutlined from "@material-ui/icons/AccountBalanceOutlined";
import SwapHoriz from "@material-ui/icons/SwapHoriz";
import CreditCardOutlined from "@material-ui/icons/CreditCardOutlined";
import { Field, InfoPanel, StepHeader } from "./ui";

export default function Financial({
  application,
  errors,
  onApplicationTextChange
}) {
  const props = { application, errors, onApplicationTextChange };
  return (
    <>
      <StepHeader
        title="Banking Information"
        detail="Enter the bank account where you'd like to receive the funds from your credit and debit card sales."
      >
        Where should we send your deposits?
      </StepHeader>
      <InfoPanel
        title="Fast, secure deposits"
        icon={AccountBalanceOutlined}
        featured
        checks={[
          "Next-day funding available (subject to approval and processing schedules)",
          "Secure and encrypted transmission",
          "Used to set up and process your merchant account"
        ]}
      >
        Your credit card sales will be deposited directly into this bank
        account, usually the following business day.
      </InfoPanel>
      <div className="merchant-grid">
        <div className="merchant-full">
          <Field
            {...props}
            name="bankName"
            label="Bank Name"
            required
            icon={AccountBalanceOutlined}
            placeholder="Example: Chase, Bank of America, Wells Fargo"
          />
        </div>
        <div className="merchant-full">
          <Field
            {...props}
            name="routingNumber"
            label="Routing Number"
            required
            icon={SwapHoriz}
            placeholder="9 digits (e.g. 123456789)"
            inputProps={{ inputMode: "numeric", maxLength: 9 }}
          />
        </div>
        <Field
          {...props}
          name="bankAccountNumber"
          label="Bank Account Number"
          required
          icon={CreditCardOutlined}
          secret
          placeholder="Enter your account number"
          inputProps={{ inputMode: "numeric" }}
          autoComplete="off"
        />
        <Field
          {...props}
          name="confirmBankAccountNumber"
          label="Re-enter Bank Account Number"
          required
          icon={CreditCardOutlined}
          secret
          placeholder="Confirm your account number"
          inputProps={{ inputMode: "numeric" }}
          autoComplete="off"
        />
      </div>
      <div className="merchant-bank-note">
        <InfoPanel title="Your banking information is protected.">
          Your banking details are used to set up your merchant account and
          process deposits.
        </InfoPanel>
      </div>
    </>
  );
}
